<template>
  <v-card flat>
    <v-card-text>
      <span v-if="provider === undefined || provider === null">
        {{ $t("components.memberfiles.no_items_message") }}
      </span>
      <pbas-data-table
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="Files"
        :rowActions="rowActions"
        identifier="FilesTable"
        :floatActions="floatActions"
        :showSelect="false"
      ></pbas-data-table>
    </v-card-text>
    <v-dialog scrollable v-model="loadingFile" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <file-dialog
      :model="fileDialog"
      @close="
        fileDialog = false;
        proof = null;
      "
      :name="getName()"
      :planNumber="planNumber"
      :planName="planName"
      :claimLines="claimLines"
      @save="saveProof"
      :proof="proof"
      :externalFiles="files"
      :isSickClaim="claimSubmission.CoverageType==='SickDay'"
    />
    <file-preview-base64
      :fullScreen="false"
      v-if="preview"
      :view="preview"
      :fileItems="fileItems"
      @close="closePreview"
    />
    <v-dialog
      scrollable
      v-model="confirmDeleteDialog"
      persistent
      max-width="400"
    >
      <material-card
        :title="$t('components.claims.claim_files_table.delete_attachment')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="confirmDeleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </v-card>
</template>

<script>
import { InMemoryProvider } from "pbas-vue-components";
import getProofHeaders from "@/headers/InMemoryProof";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import { saveAs } from "file-saver";
import FileDialog from "./FileDialog.vue";
import FilePreviewBase64 from "./FilePreviewBase64.vue";
import { previewProofHandler } from "@/mixins/previewProofHandler";
import axios from "axios";

export default {
  mixins: [previewProofHandler],
  props: [
    "claimSubmission",
    "planIdentityId",
    "memberIdentity",
    "planNumber",
    "planName",
  ],
  components: {
    ErrorHandler,
    FileDialog,
    FilePreviewBase64,
  },
  computed: {
    ...mapGetters("common", ["settings"]),
    claimLines() {
      // console.log("claimlines", this.claimSubmission);
      const lines = [];
      for (let i = 0; i < this.claimSubmission.Claims.length; i++) {
        lines.push(i + 1);
      }
      return lines;
    },
    filesIds() {
      const fileIdsSet = new Set(
        this.claimSubmission.Proofs.map((p) => {
          if (p.FileSegments) {
            return p.FileSegments.map((o) => o.PhysicalFileId);
          }
          return null;
        })
          .flat()
          .filter((o) => o !== null)
      );
      return Array.from(fileIdsSet);
    },
  },
  data() {
    return {
      fileItem: null,
      loadingFile: false,
      tooltipBackgroundColor: null,
      tooltipTextHexColor: null,
      pdfSrc: null,
      pageCount: 0,
      fullscreen: false,
      hideSidebar: true,
      src: null,
      fileData: null,
      file: null,
      saving: false,
      newId: null,
      newName: null,
      loading: false,
      error: null,
      edit: false,
      provider: undefined,
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.proof = item;
            this.fileDialog = true;
          },
        },
        {
          name: "view",
          icon: "visibility",
          title: "globals.view",
          handler: (item) => {
            const submissionId =
              this.claimSubmission.SubmissionId !== null &&
              this.claimSubmission.SubmissionId !== undefined
                ? this.claimSubmission.SubmissionId
                : "New submission";
            item.UploadName = `[${item.ClaimLines.join(",")}]-${
              item.ProofType
            }-${submissionId}`;
            this.previewProof(item);
          },
        },
        {
          name: "download",
          icon: "file_download",
          title: "globals.download",
          handler: (item) => {
            // this.tryDownloadFile(item);
            this.selectedFile = item;
            this.downloadFiles();
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.confirmDeleteDialog = true;
            this.selected = item;
          },
        },
      ],
      floatActions: [
        {
          text: "globals.add",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: () => {
            this.proof = {
              Identifier: Math.random().toString(),
            };
            this.fileDialog = true;
          },
        },
      ],
      selectedFile: null,
      fileDialog: false,
      fileItems: null,
      preview: false,
      proof: null,
      selected: null,
      confirmDeleteDialog: false,
      files: []
    };
  },
  watch: {
    claimSubmission: {
      async handler(v) {
        // console.log("c sub changed: ", v);
        if (v && v.Proofs) {
          if (this.provider === null || this.provider === undefined) {
            this.provider = new InMemoryProvider(v.Proofs, getProofHeaders(v));  
          } else {
            this.provider.items = v.Proofs;
            this.$refs.table.getDataAsync();
          }
          
          await this.loadFiles();
        }
      },
    },
    immediate: true,
  },
  async mounted() {
    // this.loadData();
    let items = [];
    if (this.claimSubmission && this.claimSubmission.Proofs) {
      items = this.claimSubmission.Proofs;
    }
    this.provider = new InMemoryProvider(
      items,
      getProofHeaders(this.claimSubmission)
    );
    await this.loadFiles();
  },
  methods: {
    ...mapActions("plansMembers", ["getEmployerFiles", "replaceEmployerFile"]),
    ...mapActions("documentsService", ["getFile", "downloadFile"]),

    tryDelete() {
      console.log("file delete: ", JSON.stringify(this.provider.items), JSON.stringify(this.selected));
      this.provider.items = this.provider.items.filter(
        (o) => o.Identifier !== this.selected.Identifier
      );
      this.$refs.table.getDataAsync();
      this.confirmDeleteDialog = false;
      // this.$emit("proofs",this.provider.items);
      this.claimSubmission.Proofs = this.provider.items;
      this.$emit("valid");
      console.log("file delete: ", JSON.stringify(this.provider.items), JSON.stringify(this.claimSubmission.Proofs));
    },
    saveProof(proof) {
      const existing = this.provider.items.filter(
        (o) => o.Identifier === proof.Identifier
      );
      if (existing.length > 0) {
        const index = this.provider.items.indexOf(existing[0]);
        this.provider.items[index] = proof;
      } else {
        this.provider.items.push(proof);
      }
      this.$refs.table.getDataAsync();
      this.fileDialog = false;
      this.proof = null;
      // this.$emit("proofs",this.provider.items);
      this.claimSubmission.Proofs = this.provider.items;
      this.$emit("valid");
    },
    getName() {
      // console.log(this.memberIdentity);
      if (this.memberIdentity === null || this.memberIdentity === undefined) {
        return;
      }
      if (this.memberIdentity.CurrentMember) {
        if (
          this.memberIdentity.CurrentMember.FirstName &&
          this.memberIdentity.CurrentMember.LastName
        ) {
          return `${this.memberIdentity.CurrentMember.FirstName} ${
            this.memberIdentity.CurrentMember.LastName
          }`;
        } else if (this.memberIdentity.CurrentMember.FirstName) {
          return this.memberIdentity.CurrentMember.FirstName;
        } else if (this.memberIdentity.CurrentMember.LastName) {
          return this.memberIdentity.CurrentMember.LastName;
        }
      }
      if (this.memberIdentity.MemberIdentification.Certificate) {
        return this.memberIdentity.MemberIdentification.Certificate;
      }
      return "";
    },
    async tryDownloadFile(item) {
      try {
        this.loadingFile = true;
        const file = (await this.$files.getFile(item.Id)).data;
        const blob = this.$files.b64toBlob(file);
        // console.log(item);
        this.loadingFile = false;
        saveAs(blob, item.FileName);
      } catch (error) {
        this.error = error;
      }
    },
    bindFile(files) {
      this.newId = files.file.Id;
      this.newName = files.file.Name;
    },
    close() {
      this.edit = false;
      this.file = null;
      this.fileItem = null;
    },
    async loadFiles() {
      try {
      this.loading = true;
      console.log(this.filesIds)
      
      this.files = await this.$files.getFiles(this.filesIds);

      console.log(this.files)
    } catch (error) {
      this.error = error;
    } finally {
      this.loading = false;
    }
    }
  },
};
</script>
<style>
.centered-div {
  margin-left: auto;
  margin-right: auto;
}
</style>
